<template>
  <v-container grid-list-md text-xs-center class="py-4 mx-auto px-2">
    <v-layout row wrap justify-start>
      <v-flex v-for="sistema in sistemasIntegrados" :key="sistema.nome" xs12 sm6 md4 lg4 class="pa-2">
        <v-card v-if="!loadingIntegracoes" class="card-sistema">
          <v-card-text class="px-0">
            <v-chip color="transparent" :style="sistema.possuiFilaRequisicoes ? 'height: 60px' : 'height: 61px'"
                    :class="sistema.possuiFilaRequisicoes ? 'mt-5 mb-4 mx-0' : 'my-5 mx-0'" disabled>
              <span class="icone-sistema text--disabled">
                  <v-icon style="font-size: 6em">
                    {{selecionarIcone(sistema)}}
                  </v-icon>
              </span>
              <v-chip color="transparent" disabled>
                <p style="font-size: 25px" class="text--secondary"> {{sistema.nome}}</p>
                <span v-if="sistema.situacao === situacoesSistemasIntegrados.OK"
                      class="mensagem-status online">
                  <v-icon style="font-size: 1.2em">circle</v-icon>
                  Online
                </span>
                <span v-else-if="sistema.situacao === situacoesSistemasIntegrados.ERRO"
                      class="mensagem-status offline">
                  <v-icon style="font-size: 1.2em">circle</v-icon>
                  Offline
                </span>
              </v-chip>
            </v-chip>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <span v-if="sistema.possuiFilaRequisicoes" class="right">
              <v-tooltip id="rtooltip" top nudge-left="45">
                <v-icon slot="activator" @click="exibirFilaRequisicoes(sistema)">
                  format_list_bulleted
                </v-icon>
                Fila de requisições
              </v-tooltip>
            </span>
          </v-card-actions>
        </v-card>
        <content-loader v-else height="200" class="elevation-2 card-loader"
                        primaryColor="#ededed" secondaryColor="#e0e0e0"/>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>

import {actionTypes, situacoesSistemasIntegrados} from "@/commons/constants";
import { ContentLoader } from 'vue-content-loader'

export default{
  name: 'SituacaoIntegracoes',
  components: {ContentLoader},
  data(){
    return{
      possuiRequisicoes: true,
      situacoesSistemasIntegrados,
      sistemasIntegrados: [{},{},{}],
      loadingIntegracoes: true
    }
  },
  methods:{
    async buscarDadosIntegracoes(){
      const dados = await this.$store.dispatch(actionTypes.BUSCAR_SITUACAO_INTEGRACOES)
      this.loadingIntegracoes = false
      this.sistemasIntegrados = dados.sistemasIntegrados
    },
    selecionarIcone(sistema){
      if(sistema.tipo === 'FORNECEDORES')
        return 'group'
      if(sistema.tipo === 'GESTAO')
        return 'gavel'
      if(sistema.tipo === 'VIRTUALIZACAO')
        return 'description'
      if(sistema.tipo === 'PAGAMENTOS')
        return 'payments'
      if(sistema.tipo === 'CONTRATACOES_PUBLICAS')
        return 'receipt_long'

      return 'settings'
    },
    exibirFilaRequisicoes(sistema){
      this.$router.push({name: 'FilaRequisicoes', params: {sistema: sistema.nome}})
    }
  },
  mounted(){
    this.buscarDadosIntegracoes()
  },
  timers:{
    buscarDadosIntegracoes:{
      time: 30000, repeat: true, autostart: true
    }
  }

}
</script>
<style>
.mensagem-status{
  font-size: 1.1em;
  color: grey;
  position: absolute;
  float: bottom;
  padding-left: 2px;
  padding-top: 30px;
}

.mensagem-status.online{
  color: green;
}

.mensagem-status.offline{
  color: red;
}

</style>

<style scoped>
.v-tooltip__content:before {
  content:"";
  position: absolute;
  left: 80%;
  top: 99%;
  width: 0;
  height: 0;

  border-left: 8px solid transparent;
  border-right: 8px solid transparent;
  border-top: 8px solid slategrey;
}
</style>
